var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwitter5310B73E96(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5005 0.5C5.87299 0.5 0.500488 5.8725 0.500488 12.5C0.500488 19.1275 5.87299 24.5 12.5005 24.5C19.128 24.5 24.5005 19.1275 24.5005 12.5C24.5005 5.8725 19.128 0.5 12.5005 0.5ZM17.3817 10.33C17.3867 10.4325 17.388 10.535 17.388 10.635C17.388 13.76 15.0117 17.3612 10.6642 17.3612C9.37961 17.3634 8.1217 16.9944 7.04174 16.2987C7.22549 16.3212 7.41424 16.33 7.60549 16.33C8.71299 16.33 9.73174 15.9538 10.5405 15.3188C10.0476 15.3091 9.57008 15.1459 9.17438 14.8519C8.77868 14.5579 8.48455 14.1478 8.33299 13.6788C8.68693 13.7461 9.05155 13.7319 9.39924 13.6375C8.8643 13.5293 8.38324 13.2395 8.03762 12.8171C7.69201 12.3947 7.50312 11.8658 7.50299 11.32V11.2913C7.82174 11.4675 8.18674 11.575 8.57424 11.5875C8.07274 11.2537 7.71772 10.7408 7.58179 10.1539C7.44587 9.56699 7.5393 8.95032 7.84299 8.43C8.43668 9.16 9.17706 9.75718 10.0162 10.1829C10.8553 10.6086 11.7745 10.8533 12.7142 10.9012C12.5948 10.3941 12.6462 9.86176 12.8605 9.38688C13.0748 8.912 13.44 8.52124 13.8993 8.27533C14.3586 8.02942 14.8863 7.94215 15.4004 8.02709C15.9144 8.11203 16.3859 8.36441 16.7417 8.745C17.2707 8.64034 17.778 8.44632 18.2417 8.17125C18.0654 8.71892 17.6963 9.18397 17.203 9.48C17.6715 9.42356 18.1291 9.2976 18.5605 9.10625C18.2436 9.58112 17.8444 9.99555 17.3817 10.33Z",
    fill: "#F1F6FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter5310B73E96);
export default __webpack_public_path__ + "static/media/icon_twitter_5310b73e96.4b21d404e7498a3ededa468790394143.svg";
export { ForwardRef as ReactComponent };